import React from "react";
import { useEffect } from "react";
import GeneralNavbar from "../../components/Navbar/GeneralNavbar";
import "./ContactPage.css";

const ContactPage = () => {
	useEffect(() => {
		// change background color when component mounts
		document.body.style.backgroundColor = "white";

		// reset background color when component unmounts
		return () => {
			document.body.style.backgroundColor = "rgb(0, 53, 107)";
		};
	}, []);
	return (
		<>
			<GeneralNavbar />
			<div className="contact-page-container">
				<h1 className="contact-page-heading">Contact</h1>
				<div className="contact-page-body">
					<p>
						For any inquiries or if you wish to collaborate with our
						team, please reach out at
						<a
							href="mailto:hyojung.seo@yale.edu"
							className="email-link"
						>
							{" "}
							hyojung.seo@yale.edu
						</a>
						.
					</p>
				</div>
			</div>
		</>
	);
};

export default ContactPage;
